import {
  SERVICE_UPDATE_SERVICES,
  SERVICE_ADD_VERSION,
  SERVICE_UPDATE_INITIALIZED
} from '@/store/mutypes';
import {
  RootState,
  Service,
  ServiceState,
  ServiceVersionInput,
  ServiceVersion
} from '@/types';
import { ActionContext } from 'vuex';
import { serviceSvc } from '@/services';

// initial state
const modState: ServiceState = {
  services: [],
  servicesInitialized: false
};

// getters
const getters = {
  getServiceById: (state: ServiceState) => (serviceId = '1'): Service => {
    const service: Service = state.services.find(
      (s: Service) => s.id === serviceId
    ) as Service;
    return service;
  },
  getServiceBySlug: (state: ServiceState) => (
    serviceSlug = 'upaffiliate'
  ): Service => {
    const service: Service = state.services.find(
      (s: Service) => s.slug === serviceSlug
    ) as Service;
    return service;
  }
};

// actions, to handle async call
const actions = {
  async initServices({
    commit,
    state
  }: ActionContext<ServiceState, RootState>) {
    try {
      if (!state.servicesInitialized) {
        const services = await serviceSvc.getServices();
        commit(SERVICE_UPDATE_SERVICES, services);
        commit(SERVICE_UPDATE_INITIALIZED, true);
      }
    } catch {
      //
    }
  },
  async createServiceVersion(
    { commit }: ActionContext<ServiceState, RootState>,
    input: ServiceVersionInput
  ) {
    const version = await serviceSvc.createServiceVersion(input);
    commit(SERVICE_ADD_VERSION, version);
    return version;
  }
};

const mutations = {
  [SERVICE_UPDATE_SERVICES](state: ServiceState, services: Service[]) {
    state.services = services;
  },
  [SERVICE_UPDATE_INITIALIZED](state: ServiceState, status: boolean) {
    state.servicesInitialized = status;
  },
  [SERVICE_ADD_VERSION](state: ServiceState, version: ServiceVersion) {
    const service: Service = state.services.find(
      (s: Service) => s.id === version.service_id
    ) as Service;
    service.versions.unshift(version);
  }
};

export default {
  state: modState,
  getters,
  actions,
  mutations
};
